<template>
  <div
    style="color: grey">
    サマリー
    <v-card>
      <v-card-text v-html="summary"/>
    </v-card>
    <br>
  </div>
</template>

<style scoped>
.v-card {
  display: flex;
  max-height: 400px;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
  white-space: pre-line
}
</style>

<script>
import format from 'date-fns/format';
import { getColor, citiesById, sourceTypeById, mileagesById, MODIFICATION_OTHER } from '../../options';


export default {
  name: 'Summary',
  props: {
    appointment: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    const details = this.getDetails(this.appointment);
    const notification = this.getNotification(this.appointment);
    const summary = `${details}\n\n${notification}`;
    return {
      summary,
    };
  },
  methods: {
    getDetails(appointment) {
      let address;
      try {
        address = JSON.parse(appointment.customer.clientCabinetCustomer.address);
      } catch (e) {
        address = '';
      }
      const prefecture = (address && address.PREFECTURE) ? address.PREFECTURE : '';
      const city = (address && address.CITY) ? address.CITY : '';
      const townArea = (address && address.TOWN_AREA) ? address.TOWN_AREA : '';
      const buildingAndRoom = (address && address.BUILDING_AND_ROOM) ? address.BUILDING_AND_ROOM : '';

      const carYear = appointment.car.year ? appointment.car.year : '';
      const carModification = appointment.car.modificationId.id === MODIFICATION_OTHER ? '' : appointment.car.modificationId.code;

      const details = [
        `申込者:${appointment.customer.lastName}${appointment.customer.name}`,
        `電話番号:<a href="tel:${appointment.customer.phone}">${appointment.customer.phone}</a>`,
        `メール:${appointment.customer.email}`,
        `都道府県:${citiesById(appointment.city)}`,
        `検査場所（店舗・出張）:${appointment.branch.name}`,
        `郵便番号:${appointment.zip}`,
        `住所:${prefecture + city + townArea + buildingAndRoom}`,
        `検査員:${appointment.inspector.lastName + appointment.inspector.name}`,
        `検査時刻:${format(new Date(appointment.time.replace(/-/g, '/')), 'yyyy-MM-dd HH:mm:00') || ''}`,
        `ソースタイプ:${sourceTypeById(appointment.campaign)}`,
        `自動車:${[appointment.car.carBrand.name, appointment.car.modelId.title, carModification, appointment.car.modificationExt, carYear].filter(v => v).join(' ')}`,
        `走行距離:${mileagesById[appointment.car.mileageId] || ''}`,
        `色:${getColor(appointment.car.colorId)}`,
        `ローン残債:${appointment.carLoanToBePaidAmount}円`,
      ];
      return details.join('\n\n');
    },
    getNotification(appointment) {
      if (appointment.notification == null) {
        return '';
      }

      const fixedPhone = '0([1-9]{1}-?[1-9]\\d{3}|[1-9]{2}-?\\d{3}|[1-9]{2}\\d{1}-?\\d{2}|[1-9]{2}\\d{2}-?\\d{1})-?\\d{4}';
      const mobilePhone = '0[789]0-?\\d{4}-?\\d{4}';
      const ipPhone = '050-?\\d{4}-?\\d{4}';

      const phoneRegex = new RegExp(`(${[fixedPhone, mobilePhone, ipPhone].join('|')})`, 'g');

      const notification = appointment.notification.replace(phoneRegex, phone => `<a href="tel:${phone}">${phone}</a>`);
      return `備考:${notification}`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/elements/CpAppointmentSummary.vue